import React from 'react';
import { useAuthStore } from '../store/auth/store';
import LoginFormContainer from './components/LoginFormContainer';
import LoginForm from './components/LoginForm';
import SignInLWAButton from './components/SignInLWAButton';
import { loginTerms as lt } from '../constants';
import { useQuery } from '../common/hooks/location';

const Login = () => {
    const {
        authKeycloakUser,
    } = useAuthStore(state => ({
        authKeycloakUser: state.authKeycloakUser,
    }));

    const query = useQuery();
    const redirectPath = query.get('redirect');

    const handleSubmitForm = (state, setState, history) => {
        authKeycloakUser(state, setState, history, redirectPath);
    };

    return (
        <LoginFormContainer>
            <LoginForm submitForm={handleSubmitForm}>
                <>
                    <div className='d-flex justify-content-center'>
                        <p className='or-divider m-0'>{lt.or}</p>
                    </div>
                    <SignInLWAButton />
                </>
            </LoginForm>
        </LoginFormContainer>
    );
};

export default Login;
